import './add';
import './expire';
import './notification-prefs';
import './update';

import './cancel-invite-modal.controller.js';
import './shop-operators.component.js';
import './shop-operators.controller.js';
import './shop-operators.service.js';

angular.module('inkfinder').config(function($stateProvider, USER_ROLES) {
  $stateProvider.state('inkfinder.shop.operators', {
    url: '/operators',
    views: {
      shop: {
        component: 'inkShopOperators'
      }
    },
    resolve: {
      $title: function() {
        return 'Shop operators';
      }
    }
  });
});



// WEBPACK FOOTER //
// ./components/shop/operators/index.js